import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";

export default function Register() {
  const navigate = useNavigate();

  return (
    <div className="bg-[#021610] text-white min-h-screen flex flex-col">
      {/* NAVBAR */}
      <div className="fixed top-0 left-0 w-full bg-black/80 backdrop-blur-md z-20 flex items-center px-6 py-2">
        <button onClick={() => navigate("/tickets-store/")}>
          <img
            src={logo}
            alt="Afrodise"
            className="h-6 md:h-8 object-contain hover:opacity-80 transition"
          />
        </button>
      </div>

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="text-center space-y-4">
          <p className="text-4xl">🔐</p>
          <h1 className="text-2xl font-bold">Crea tu cuenta</h1>
          <p className="text-sm text-gray-400">
            Este evento requiere una cuenta para completar la compra.
          </p>
          <p className="text-xs text-gray-600 tracking-widest uppercase">
            Página en construcción
          </p>
        </div>
      </div>
    </div>
  );
}